<template>
    <div class="fold" :class="calssName" ref="fold">
        <div class="fold-title" @click.stop="unfoldFn">
            <div class="fold-title_label">
                <span>{{label}}</span>
            </div>
            <div class="fold-title_arrow">
                <span>{{text}}</span>
            </div>
        </div>
        <div class="fold-content">
            <slot></slot>
        </div>
    </div>
</template>
<script>
export default {
    name:"Fold",
    props:{
        label:{
            type: String,
            required: true
        },
        text: [String,Number],
        required: Boolean,
        unfold: Boolean,
        disabled: Boolean,
        error:Boolean
    },
    data(){
        return {
            isOpen: this.unfold
        }
    },
    watch:{
        unfold(newVal){
            this.isOpen = newVal;
        }
    },
    computed:{
        calssName(){
            return {
                'is-required': this.required,
                'is-open': this.isOpen,
                'is-error': this.error,
                'is-disabled': this.disabled
            };
        }
    },
    methods:{
        unfoldFn(){
            if(this.disabled) return;
            this.isOpen = !this.isOpen;
            this.$emit('unfold-change', this.$refs['fold'], this.isOpen);
        }
    }
}
</script>
<style lang="scss">
.fold{
    width: 100%;
    height: auto;
    background: #ffffff;
    box-shadow: 0px 0.04rem 0.2rem -0.04rem rgb(136 136 136 / 25%);
    border-radius: 0.2rem;
    margin-bottom: 24px;
    padding: 8px 40px;
    box-sizing: border-box;
    &.is-error{
        position: relative;
        &::after{
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            border-radius: 20px;
            animation: error 0.25s linear;
            animation-iteration-count: 3;
            pointer-events: none;
        }
    }
    &.is-required{
        .fold-title{
            .fold-title_label{
                padding-right: 48px;

                @include bg-image('~@images/icon/icon_card_未完成必填项提示_星号');
                background-repeat: no-repeat;
                background-size: 48px 48px;
                background-position: 100%  50%;
            }
        }
    }
    &.is-open{
        .fold-title .fold-title_arrow{
            @include bg-image("~@images/icon/icon_card_箭头_绿色_向上");
            span{
                display: none;
            }
        }
        .fold-content{
            display: block;
        }
    }
    &.is-disabled{
        .fold-title .fold-title_arrow{
            @include bg-image("~@images/icon/card_arrow_down_4", false);
        }
    }
    .fold-title{
        height: 92px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .fold-title_label{
            max-width: 50%;
            height: 100%;
            display: flex;
            align-items: center;
            box-sizing: border-box;
            position: relative;
            span{
                display: inline-block;
                font-size: 32px;
                color: #1B1C1E;
                font-weight: 500;
                @include ellipsis;
            }
        }
        .fold-title_arrow{
            width: 50%;
            height: 100%;
            padding-right: 40px;
            box-sizing: border-box;
            @include bg-image("~@images/icon/icon_card_箭头_绿色_向下");
            background-repeat: no-repeat;
            background-size: 48px 48px;
            background-position: calc(100% + 12px) center;

            display: flex;
            align-items: center;
            span{
                width: 100%;
                height: 40px;
                display: inline-block;
                font-size: 28px;
                color: #1B1C1E;
                text-align: right;
                font-weight: 500;
                line-height: 40px;
                @include ellipsis;
            }
        }
    }
    .fold-content{
        width: 100%;
        height: auto;
        padding-bottom: 24px;
        display: none;
    }
}
@keyframes error{
    from{
        background: rgba(240,110,67,0) ;
    }
    to{
        background: rgba(240,110,67,0.06) ;
    }
}
</style>